import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";

import InputField from "../../../components/InputField";
import axiosInstance from "../../../utils/axiosInstance";
import { addEditExperience, fetchDoctorProfile, fetchDoctorServicesList, registerUser, updateUserDetais } from "../../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../../components/FullPageLoader";
import ListEmptyText from "../../../components/ListEmptyText";
import MyModal from "../../../components/MyModal";

export default function ManageExperience() {
  pageTitle("Manage Experience");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const [editExperienceData, setEditExperienceData] = useState();
  const [deleteExperienceId, setDeleteExperienceId] = useState("");
  const [editExperienceModalOpen, setEditExperienceModalOpen] = useState(false);
  const [deleteExperienceModalOpen, setDeleteExperienceModalOpen] = useState(false);
  const [addExperienceModalOpen, setAddExperienceModalOpen] = useState(false);
  const [addExperienceData, setAddExperienceData] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditPress = (expertiseData) => {
    setEditExperienceData(expertiseData);
    setEditExperienceModalOpen(true);
  };

  const handleDeletePress = (expertiseData) => {
    setDeleteExperienceId(expertiseData.id);
    setDeleteExperienceModalOpen(true);
  };

  const handleOpenAddServiceModal = () => {
    setAddExperienceModalOpen(true);
    setAddExperienceData({ title: "" });
  };

  const closeAddModal = () => setAddExperienceModalOpen(false);
  const closeEditModal = () => setEditExperienceModalOpen(false);
  const closeDeleteModal = () => setDeleteExperienceModalOpen(false);

  const onAddSubmit = () => {
    if (!editExperienceData?.title === "") {
      toast.error("Please provide Experience title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditExperience, {
        doctor_id: doctorId,
        title: addExperienceData?.title,
        type: 1,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Experience added successfully.");
          setAddExperienceData("");
          setAddExperienceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onEditSubmit = () => {
    if (!editExperienceData?.title === "") {
      toast.error("Please provide Experience title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditExperience, {
        doctor_id: doctorId,
        title: editExperienceData?.title,
        experience_id: editExperienceData?.id,
        type: 2,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Experience updated successfully.");
          setEditExperienceData("");
          setEditExperienceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onDeleteClick = () => {
    setSubmitting(true);
    axiosInstance
      .post(addEditExperience, {
        doctor_id: doctorId,
        experience_id: deleteExperienceId,
        type: 3,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Experience deleted successfully.");
          setDeleteExperienceId("");
          setDeleteExperienceModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Experience"
              trailing={
                <button type="button" className="bg-success-surface px-3 rounded" onClick={handleOpenAddServiceModal}>
                  Add Experience
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark">MANAGE EXPERIENCE</strong>
                  <p className="text-grey2 fs-normal">Example: Allergies/Immunologists, Anesthesiologists, Cardiologists, Dermatologists, Etc.</p>
                </div>
              </div>
              <div className="col-md-6">
                {!loading && doctorDetail && doctorDetail?.experience.length === 0 && <ListEmptyText text={"No Expertise added yet."} />}
                {!loading && doctorDetail && doctorDetail?.experience.length > 0 && (
                  <div className="w-full">
                    {doctorDetail?.experience.map((experience) => (
                      <div key={experience.id} className="d-flex justify-content-between bg-grey2 mb-2 rounded">
                        <strong className="fs-normal text-grey2 fw-normal px-3 py-2  ">{experience.title}</strong>
                        <div className="d-flex gap-2">
                          <button type="button" className="bg-warning-surface px-3 rounded" onClick={() => handleEditPress(experience)}>
                            Edit
                          </button>
                          <button type="button" className="bg-danger-surface px-3 rounded" onClick={() => handleDeletePress(experience)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Expertise Modal */}
      <MyModal isOpen={editExperienceModalOpen} modalTitle={"Edit Experience"} onClose={closeEditModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"experienceName"} value={editExperienceData?.title} onChange={(e) => setEditExperienceData({ ...editExperienceData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onEditSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Add Expertise Modal */}
      <MyModal isOpen={addExperienceModalOpen} modalTitle={"Add Experience"} onClose={closeAddModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"experienceName"} value={addExperienceData?.title} onChange={(e) => setAddExperienceData({ ...addExperienceData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onAddSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Delete Modal */}
      <MyModal isOpen={deleteExperienceModalOpen} modalTitle={"Delete Experience"} onClose={closeDeleteModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <SecondaryButton title="Delete" onClick={onDeleteClick} loading={submitting} />
        </div>
      </MyModal>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
